<template>
  <div>
    <nav-title :color="false" :title="'Problem Solving saved'" />
    <section class="container">
      <h5 class="text-center py-3 m-0">
        <span class="material-icons align-middle small text-main">
          emoji_objects
        </span>
        {{ $route.query.name }}
      </h5>
      <div class="mx-lg-5" v-for="(value, title, index) in configurations" :key="index + title">
        <list-antecedents :title="title" :antecedents="value" color="#929FA4" />
      </div>
      <p class="p-3 mx-lg-5">
        Please choose a skill(s) to learn more about solutions for this problem and to set parent
        goals for this problem.
      </p>
      <skill-list :options="skills" />
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import store from '@/store';
import navTitle from '@/components/general/navTitle.vue';
import { ListAntecedents, skillList } from '@/components/help';

export default {
  components: {
    navTitle,
    skillList,
    ListAntecedents,
  },
  computed: {
    ...mapGetters('help', ['configurationById']),
    configurationId() {
      return this.$route.query.problem;
    },
    skills() {
      return (
        this.configurationById(this.configurationId).skill_problem.map((data) => data.skill) || []
      );
    },
    configurations() {
      return (
        this.adaptConfigurations(this.configurationById(this.configurationId).to_change_problem) ||
        {}
      );
    },
  },
  methods: {
    adaptConfigurations(configuration = {}) {
      const keys = Object.keys(configuration);
      let configurationMapped = {};
      keys.forEach((key) => {
        const data = configuration[key].map((categoryConfig) => categoryConfig.to_change);
        configurationMapped = { ...configurationMapped, [key]: data };
      });
      return configurationMapped;
    },
  },
  beforeRouteEnter(to, from, next) {
    const parentId = store.getters['user/getUserId'];
    Promise.all([store.dispatch('help/FetchConfig', parentId)]).then(() => {
      next();
    });
  },
};
</script>
